export default __webpack_public_path__ + "static/media/table_cancer_Hk.94d8af34.webp";